import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import * as selector from "./selectors";
import * as action from "../layout/actions";
import { Route } from "react-router-dom";
import { withRouter } from "react-router-dom";
import { isEnabledForOrganizationPrefix } from "utils/organizationUtils";

const AuthorizedRoute = ({ accessPermissions, organizationPrefix, permissionsShouldMatchOrganization, ...props }) => {
	const dispatch = useDispatch();

	const currentUser = useSelector(selector.selectCurrentUser);
	const organizations = useSelector(selector.selectOrganizations);
	const isAuthSet = accessPermissions;
	const hasPermission = isAuthSet && currentUser.permissions?.some(up => accessPermissions.includes(up));
	const orgsLoaded = !organizationPrefix || organizations?.length > 0;
	const hasOrgAccess = !organizationPrefix || !orgsLoaded || isEnabledForOrganizationPrefix(organizations, currentUser, organizationPrefix, accessPermissions, permissionsShouldMatchOrganization);
	const isAuthorized = hasPermission && hasOrgAccess;

	useEffect(() => {
		if (orgsLoaded && !isAuthorized && isAuthSet) {
			props.history.goBack();
			dispatch(action.error_notify(["Not enough user rights for this action."]));
		}
	}, [orgsLoaded, isAuthorized]);

	return <>{(currentUser.permissions || !isAuthSet) && <Route key={props.key} exact={props.exact} path={props.path} component={props.component} />}</>;
};

export default withRouter(AuthorizedRoute);
